import { render } from "./FormChangePassword.vue?vue&type=template&id=c7af75a8"
import script from "./FormChangePassword.vue?vue&type=script&lang=js"
export * from "./FormChangePassword.vue?vue&type=script&lang=js"

import "./FormChangePassword.vue?vue&type=style&index=0&id=c7af75a8&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__